var $9b8377da3e9e77bf$exports = {};
const $9b8377da3e9e77bf$var$secondsRef = document.querySelector(".seconds2");
const $9b8377da3e9e77bf$var$objectRef = document.querySelector(".object");
let $9b8377da3e9e77bf$var$total2 = 30;
const $9b8377da3e9e77bf$var$reverseTimer2 = setInterval(()=>{
    $9b8377da3e9e77bf$var$total2 -= 1;
    if ($9b8377da3e9e77bf$var$total2 <= 10) {
        $9b8377da3e9e77bf$var$objectRef.style.transition = "250ms cubic-bezier(0.4, 0, 0.2, 1)";
        $9b8377da3e9e77bf$var$objectRef.style.transform = "translateX(1500px)";
    }
    if ($9b8377da3e9e77bf$var$total2 <= 0) {
        clearInterval($9b8377da3e9e77bf$var$reverseTimer2);
        $9b8377da3e9e77bf$var$objectRef.classList.remove("object");
        return;
    }
    const seconds = $9b8377da3e9e77bf$var$total2 % 60;
    $9b8377da3e9e77bf$var$secondsRef.textContent = seconds < 10 ? "0" + seconds : seconds;
}, 1000);


//# sourceMappingURL=JS4-HW11.d3c1002f.js.map
